export default import.meta.ROLLDOWN_FILE_URL_1SH_3pIjoy69NhNnABNVtA